(function(window, document) {
  'use strict';

  const prefix = $('.vodl-select-region__current').attr('data-mytown-prefix');

  $(document).ready(function() {
    let button = $('.vodl-select-hyperlocal-region__submit').children();

    button.on('click', vodlSetCookie);
  });

  function vodlSetCookie() {
    let town = document.querySelector('.vodl-select-hyperlocal-region__wrapper .vodl-select-region__current').dataset
      .mytownSlug;

    const time = new Date();
    time.setFullYear(time.getFullYear() + 1);

    let domain = window.location.hostname;
    let domainArray = domain.split('.');
    if ('www' === domainArray[0] || 'nnp' === domainArray[0]) {
      domain = domain.replace(domainArray[0], '');
    }

    document.cookie = 'CurrentCity=' + town + '; path=/; domain=' + domain + '; expires=' + time.toUTCString() + ';';
    window.location.href = '/' + prefix + '/' + town;
  }
})(window, document);